import React from 'react'

export default function AboveHeader() {
    return (
        <div className='above-header'>
            <p>Healthy = Happy</p>
        </div>
    )
}
